import CommunicationManagementForm from "../../modules/communication-management/forms/CommunicationManagementForm.vue";
import CommunicationManagement from "../../modules/communication-management/views/CommunicationManagement.vue";
import RouterViewRender from "../../utils/routes/router-view-render";
import CommunicationManagementReport from "../../modules/communication-management/views/CommunicationManagementReport.vue"

const CommunicationManagementRoutes = {
  path: "",
  component: RouterViewRender,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "gestao-comunicacao",
      component: CommunicationManagement,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "formulario-gestao-comunicacao",
      component: CommunicationManagementForm,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "formulario-gestao-comunicacao/:id",
      component: CommunicationManagementForm,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "relatorio-gestao-comunicacao",
      component: CommunicationManagementReport,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default CommunicationManagementRoutes;
